/* Accordion  */
function initAcc(elem, option) {
    document.addEventListener("click", function (e) {
      if (!e.target.matches(elem + " .a-btn")) return;
      else {
        // Button is NOT in active container
        if (!e.target.parentElement.classList.contains("active")) {
          var elementList = document.querySelectorAll(elem + " .a-container");
          Array.prototype.forEach.call(elementList, function (e) {
            e.classList.remove("active");
            console.log(e.children[0]);
            e.children[0].setAttribute("aria-expanded", "false");
          });
          e.target.setAttribute("aria-expanded", "true");
  
          e.target.parentElement.classList.add("active");
        }
        // Button is in active container
        else {
          e.target.setAttribute("aria-expanded", "false");
          e.target.parentElement.classList.remove("active");
        }
      }
    });
  }
  
  initAcc(".accordion", true);